import { SlidersHorizontal } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface ColumnOption {
  id: string;
  label: string;
}

export interface ColumnsMenuProps {
  /** Toggleable columns (identity/core columns are omitted — always shown). */
  columns: ColumnOption[];
  isVisible: (id: string) => boolean;
  onToggle: (id: string) => void;
}

/**
 * A "Columns" dropdown of checkboxes letting the user hide/show table columns.
 * Pairs with `useColumnVisibility`. Toggling keeps the menu open so several
 * columns can be adjusted at once.
 */
export function ColumnsMenu({
  columns,
  isVisible,
  onToggle,
}: ColumnsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm-touch" className="gap-2">
          <SlidersHorizontal className="h-4 w-4" />
          Columns
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel>Show columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {columns.map((column) => (
          <DropdownMenuCheckboxItem
            key={column.id}
            checked={isVisible(column.id)}
            // Keep the menu open while toggling multiple columns.
            onSelect={(event) => event.preventDefault()}
            onCheckedChange={() => onToggle(column.id)}
          >
            {column.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
